import * as React from 'react'
import { useTranslation } from '~/hooks/useTranslation'

export function StatusCell({ row }) {
  const { t } = useTranslation('StatusCell')
  const feedback = row.original

  const completed = feedback.completed_at

  const completedAtDate = new Date(feedback?.completed_at).toLocaleDateString(
    undefined,
    {
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
    },
  )

  const status = completed
    ? `${t('completed')} - ${completedAtDate}`
    : t('progress')

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="flex flex-row items-center gap-1 text-sm">
        <div className="flex flex-col">
          <div className="flex gap-2">{status}</div>
        </div>
      </div>
    </div>
  )
}
